import multimediaEvents from '../components/question/media/multimedia/MultimediaEvents';

let topResolve;
let listener;
let sequence = [];
let currentlyPlayingLogicalName;

export const outcomes = {
    CANCELED: 'canceled',
    COMPLETED: 'completed',
    ERROR: 'error',
};

function reset() {
    sequence = [];
    topResolve = undefined;
    listener = undefined;
    currentlyPlayingLogicalName = undefined;
    window.removeEventListener(multimediaEvents.MEDIA_PLAYED_TO_COMPLETION, listener);
    window.removeEventListener(multimediaEvents.START_PLAYING, listener);
    window.removeEventListener(multimediaEvents.STOP_ALL_PLAYBACK, listener);
}

function mediaEventListener(event) {
    if (event.type === multimediaEvents.MEDIA_PLAYED_TO_COMPLETION) {
        onMediaPlayedToCompletion(event);
    } else if (event.type === multimediaEvents.START_PLAYING) {
        onStartPlaying(event.detail);
    } else if (event.type === multimediaEvents.STOP_ALL_PLAYBACK) {
        onStopAllPlayback(event.detail);
    }
}

function onStopAllPlayback(detail) {
    if (detail && detail.triggeredBy !== currentlyPlayingLogicalName) {
        cancelSequence();
    }
}

function onStartPlaying(detail) {
    if (detail && detail.logicalName !== currentlyPlayingLogicalName) {
        cancelSequence();
    }
}

function onMediaPlayedToCompletion(event) {
    const playedIndex = sequence.indexOf(event.detail.logicalName);
    if (playedIndex === -1) {
        return;
    }

    if (sequence.length < playedIndex + 2) {
        onCompleted();
        return;
    }

    playItemAtIndex(playedIndex + 1);
}

function onCompleted() {
    topResolve(outcomes.COMPLETED);
    reset();
}

function listenForMediaEvents() {
    listener = mediaEventListener;
    window.addEventListener(multimediaEvents.MEDIA_PLAYED_TO_COMPLETION, listener);
    window.addEventListener(multimediaEvents.START_PLAYING, listener);
    window.addEventListener(multimediaEvents.STOP_ALL_PLAYBACK, listener);
}

function playItemAtIndex(index) {
    currentlyPlayingLogicalName = sequence[index];
    window.dispatchEvent(new CustomEvent(
        multimediaEvents.START_PLAYING,
        { detail: { logicalName: currentlyPlayingLogicalName, fromStart: true } },
    ));
}

function cancelSequence() {
    if (typeof topResolve === 'function') {
        topResolve(outcomes.CANCELED);
    }

    reset();
    window.dispatchEvent(new Event(multimediaEvents.STOP_ALL_PLAYBACK));
}

function startSequence(logicalNames) {
    cancelSequence();
    sequence = [...logicalNames];
    listenForMediaEvents();
    playItemAtIndex(0);

    return new Promise((resolve) => {
        topResolve = resolve;
    });
}

const playSequenceService = {
    cancelSequence,
    startSequence,
};

export default playSequenceService;
